import { render, staticRenderFns } from "./selectCommodity2.vue?vue&type=template&id=6fda4173&scoped=true"
import script from "./selectCommodity2.vue?vue&type=script&lang=js"
export * from "./selectCommodity2.vue?vue&type=script&lang=js"
import style0 from "./selectCommodity2.vue?vue&type=style&index=0&id=6fda4173&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fda4173",
  null
  
)

export default component.exports